import { Check, Copy } from "lucide-react";

interface DataRepoQuestionKeysPanelBodyProps {
  keys: string[];
  loading: boolean;
  fetchError: string | null;
  copiedKey: string | null;
  onCopyKey: (k: string) => void;
}

export default function DataRepoQuestionKeysPanelBody({
  keys,
  loading,
  fetchError,
  copiedKey,
  onCopyKey,
}: DataRepoQuestionKeysPanelBodyProps) {
  return (
    <ul
      className="max-h-[min(260px,45vh)] space-y-px overflow-y-auto overscroll-contain py-0.5"
      role="listbox"
      aria-label="Question field keys"
    >
      {loading && keys.length === 0 && !fetchError && (
        <li className="py-4 text-center text-[12px] text-slate-500">Loading…</li>
      )}
      {fetchError && (
        <li className="rounded-md px-2 py-2 text-[12px] leading-snug text-amber-800">{fetchError}</li>
      )}
      {!loading && !fetchError && keys.length === 0 && (
        <li className="px-1 py-2 text-[12px] text-slate-500">
          No qr_, profile_, or piv_ fields in sample.
        </li>
      )}
      {!loading &&
        !fetchError &&
        keys.map((k) => (
          <li key={k}>
            <button
              type="button"
              className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left font-mono text-[11px] text-slate-800 hover:bg-slate-100 focus:bg-slate-100 focus:outline-none"
              title={k}
              onClick={() => onCopyKey(k)}
            >
              <span className="min-w-0 flex-1 break-all">{k}</span>
              {copiedKey === k ? (
                <Check size={13} className="shrink-0 text-emerald-600" aria-hidden />
              ) : (
                <Copy size={13} className="shrink-0 text-slate-400" aria-hidden />
              )}
            </button>
          </li>
        ))}
    </ul>
  );
}
